import { call, put, takeLatest } from "redux-saga/effects";
import { API } from "../../../api/api";
import { gamesAPI } from "../api/api";
import { GamesActionTypes } from "../actions/actionTypes";

function* getGameCategories(action) {
    try {
        const categories = yield call(() => gamesAPI.getGameCategories());

        yield put({
            type: GamesActionTypes.GET_GAME_CATEGORIES_SUCCESS,
            payload: {
                categories: categories.data
            }
        });
    } catch (e) {
        API.handleError(e.response, "Error getting game category list.");

        yield put({
            type: GamesActionTypes.GET_GAME_CATEGORIES_FAIL,
            message: e.message
        });
    }
}

function* saveGameCategory(action) {
    try {
        const { category, subsidiaryIds } = action.payload;

        let categoryId = category.id;
        if (categoryId) {
            yield call(() => gamesAPI.editGameCategory(categoryId, category));
        } else {
            const created = yield call(() =>
                gamesAPI.createGameCategory(category)
            );
            categoryId = created.data.id;
        }

        // the association endpoints take one market at a time, so the current
        // selection is diffed against what the category already had
        const current = category.subsidiary_ids || [];
        const wanted = subsidiaryIds || [];

        for (const subsidiaryId of wanted.filter(id => !current.includes(id))) {
            yield call(() =>
                gamesAPI.addCategorySubsidiary(categoryId, subsidiaryId)
            );
        }

        for (const subsidiaryId of current.filter(id => !wanted.includes(id))) {
            yield call(() =>
                gamesAPI.removeCategorySubsidiary(categoryId, subsidiaryId)
            );
        }

        yield put({ type: GamesActionTypes.SAVE_GAME_CATEGORY_SUCCESS });
        yield put({ type: GamesActionTypes.GET_GAME_CATEGORIES });
    } catch (e) {
        API.handleError(e.response, "Error saving game category.");

        yield put({
            type: GamesActionTypes.SAVE_GAME_CATEGORY_FAIL,
            message: e.message
        });

        // the category may already exist with only some of its markets, so
        // the list has to be re-read rather than left showing the old state
        yield put({ type: GamesActionTypes.GET_GAME_CATEGORIES });
    }
}

function* deleteGameCategory(action) {
    try {
        yield call(() =>
            gamesAPI.deleteGameCategory(action.payload.categoryId)
        );

        yield put({ type: GamesActionTypes.DELETE_GAME_CATEGORY_SUCCESS });
        yield put({ type: GamesActionTypes.GET_GAME_CATEGORIES });
    } catch (e) {
        API.handleError(e.response, "Error deleting game category.");

        yield put({
            type: GamesActionTypes.DELETE_GAME_CATEGORY_FAIL,
            message: e.message
        });
    }
}

export function* getGameCategoriesWatcher() {
    yield takeLatest(GamesActionTypes.GET_GAME_CATEGORIES, getGameCategories);
}

export function* saveGameCategoryWatcher() {
    yield takeLatest(GamesActionTypes.SAVE_GAME_CATEGORY, saveGameCategory);
}

export function* deleteGameCategoryWatcher() {
    yield takeLatest(GamesActionTypes.DELETE_GAME_CATEGORY, deleteGameCategory);
}
